import React, { Fragment, useContext, useEffect } from "react";
import {
  Grid,
  Paper,
  FormControlLabel,
  Switch,
  FormHelperText,
  TextField,
  InputLabel,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import StoreContext from "../../../../context/stores/StoreContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "1rem",
    marginLeft: "8px",
    height: 460,
  },
  paperBox: {
    padding: "0.5rem",
  },
  field: {
    padding: theme.spacing(1, 1, 0, 1),
  },
  field2: {
    padding: theme.spacing(2, 1, 0, 1),
  },
  switch: {
    margin: 0,
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const StoreForm = ({ formType, handleChange }) => {
  const classes = useStyles();

  const {
    default_form_data,
    default_form_error,
    selected_store,
    form_data,
    form_error,
    setFormData,
    setFormError,
  } = useContext(StoreContext);

  useEffect(() => {
    if (formType === "Create") {
      setFormData(default_form_data);
      setFormError(default_form_error);
    }
  }, []);

  useEffect(() => {
    if (selected_store && formType === "Edit") {
      let data = JSON.parse(JSON.stringify(selected_store));

      setFormData({
        status: "status" in data ? data.status : true,
        cod: "cod" in data ? data.cod : false,
        base_url: data.base_url ? data.base_url : "",
        api_key: data.api_key ? data.api_key : "",
        api_secret: data.api_secret ? data.api_secret : "",
        store_name: data.store_name ? data.store_name : "",
        shared_secret: data.shared_secret ? data.shared_secret : "",
        webhooks: data.webhooks ? data.webhooks : "",
      });
      setFormError(default_form_error);
    }
  }, [selected_store]);

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        className={classes.paperBox}
      >
        {/* Shopify Activate */}{" "}
        <Grid item xs={3} className={classes.field}>
          <FormControlLabel
            className={classes.switch}
            label="Shopify Activate"
            labelPlacement="start"
            control={
              <Switch
                id="status"
                size="small"
                color="primary"
                checked={form_data.status}
                onChange={handleChange}
              />
            }
          />{" "}
          <FormHelperText>
            {" "}
            Turn off when shopify is deactivated.{" "}
          </FormHelperText>{" "}
        </Grid>
        {/* COD Activate */}{" "}
        <Grid item xs className={classes.field}>
          <FormControlLabel
            className={classes.switch}
            label="COD Activate"
            labelPlacement="start"
            control={
              <Switch
                id="cod"
                size="small"
                color="primary"
                checked={form_data.cod}
                onChange={handleChange}
              />
            }
          />{" "}
          <FormHelperText> Turn on for COD Store. </FormHelperText>{" "}
        </Grid>
        {/* Base URL */}{" "}
        <Grid item xs={12} className={classes.field}>
          <TextField
            required
            fullWidth
            size="small"
            margin="dense"
            label="Base URL"
            id="base_url"
            name="base_url"
            value={form_data.base_url}
            onChange={handleChange}
            error={form_error.base_url ? true : false}
            helperText={form_error.base_url}
          />{" "}
        </Grid>
        {/* Shared Secret */}{" "}
        <Grid item xs={6} className={classes.field}>
          <TextField
            required
            fullWidth
            size="small"
            margin="dense"
            label="Shared Secret"
            id="shared_secret"
            name="shared_secret"
            value={form_data.shared_secret}
            onChange={handleChange}
            error={form_error.shared_secret ? true : false}
            helperText={form_error.shared_secret}
          />{" "}
        </Grid>
        {/* API Key */}{" "}
        <Grid item xs={6} className={classes.field}>
          <TextField
            disabled
            required
            fullWidth
            size="small"
            margin="dense"
            label="API Key"
            id="api_key"
            name="api_key"
            value={form_data.api_key}
          />{" "}
        </Grid>
        {/* Store Name */}{" "}
        <Grid item xs={6} className={classes.field}>
          <TextField
            disabled
            required
            fullWidth
            size="small"
            margin="dense"
            label="Store Name"
            id="store_name"
            name="store_name"
            value={form_data.store_name}
          />{" "}
        </Grid>
        {/* API Secret */}{" "}
        <Grid item xs={6} className={classes.field}>
          <TextField
            disabled
            required
            fullWidth
            size="small"
            margin="dense"
            label="API Secret"
            id="api_secret"
            name="api_secret"
            value={form_data.api_secret}
          />{" "}
        </Grid>
        {formType === "Edit" && "webhooks" in form_data && (
          <Fragment>
            {" "}
            {/* Webhooks */}{" "}
            <Grid item xs className={classes.field2}>
              <Grid item>
                <InputLabel disabled shrink margin="dense">
                  Webhooks:
                </InputLabel>{" "}
              </Grid>
              <Grid item container spacing={1}>
                {" "}
                {form_data.webhooks.map((webhook, index) => (
                  <Grid item key={index}>
                    <Button
                      variant="outlined"
                      color="primary"
                      className={classes.button}
                    >
                      {webhook.topic}{" "}
                    </Button>{" "}
                  </Grid>
                ))}{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Fragment>
        )}{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default StoreForm;
